import React from "react"

import {
    ListGroup,
} from "react-bootstrap"

import {
    ChevronRight,
} from "react-bootstrap-icons"

const EMETLUnitTreeCell = (props) => {
    const { 
        onSelect, 
        selected = false,
        onContextOpen, 
        unitID,
        name,
    } = props

    const position = (e) => {
        if(e.pageX || e.pageY)
        {
            return {
                x: e.pageX,
                y: e.pageY
            }
        }
        if(e.clientX || e.clientY)
        {
            return {
                x: e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft,
                y: e.clientY + document.body.scrollTop + document.documentElement.scrollTop
            }
        }
        return { x: 0, y: 0 }
    }

    return (
        <ListGroup.Item
            action
            active={selected}
            onClick={onSelect}
            onContextMenu={(e) => {
                e.preventDefault()
                window.focus()
                const pos = position(e)
                onContextOpen(
                    pos.x,
                    pos.y,
                    unitID
                )
            }}
        >
            <div 
                className="unitTreeCell"
            >
                <div 
                    style={{ flex: 5 }}
                >
                    {name}
                </div>
                <ChevronRight 
                    style={{ flex: 1 }} 
                />
            </div>
        </ListGroup.Item>
    )
}

export default EMETLUnitTreeCell